import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

export const findAttributeGroupsQueryOptions = (args: unknown) =>
  queryOptions({
    queryKey: ['attribute-groups', args],
    queryFn: () =>
      apiClient['attribute-groups'].$get().then((r) => formatClientResponse(r)),
  })

export const useFindAttributeGroups = (
  args?: unknown,
  options?: Partial<ReturnType<typeof findAttributeGroupsQueryOptions>>
) =>
  useQuery({
    ...findAttributeGroupsQueryOptions(args),
    ...options,
  })
